import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { reduxForm, Field } from 'redux-form'
import { NOTE_CONTENT_MAX_LENGTH } from 'const/limits'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Button,
  ButtonGroup
} from 'react-bootstrap'
import RichTextFormField from 'components/RichText/FormField'

export class AddNoteForm extends React.Component {
  static propTypes = {
    boardId: PropTypes.number.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    onCancelClick: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.renderNameField = this.renderNameField.bind(this)
  }

  renderNameField (field) {
    return (
      <FormGroup
        validationState={field.meta.touched && field.meta.error ? 'error' : null}
      >
        <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
        <FormControl
          {...field.input}
          name={null}
          type='text' />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  render () {
    const { boardId, handleSubmit, submitting, onCancelClick } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name='name'
          component={this.renderNameField} />
        <FormGroup>
          <Field
            name='content'
            component={RichTextFormField}
            props={{
              richTextEditorProps: {
                autoFocus: true,
                mentionBoardId: boardId,
                checklistBlockTypes: true,
                maxLength: NOTE_CONTENT_MAX_LENGTH,
                submitButton: false,
                onSubmit: () => handleSubmit()
              }
            }}
          />
        </FormGroup>
        <ButtonGroup>
          <Button type='submit' bsStyle='primary' disabled={submitting}><FormattedMessage id='ADD' /></Button>
          <Button onClick={onCancelClick}><FormattedMessage id='CANCEL' /></Button>
        </ButtonGroup>
      </form>
    )
  }
}

export default reduxForm({
  form: 'addNote'
})(AddNoteForm)
